





















import { Component, Vue } from 'vue-property-decorator';
import { IFacet } from '../Scripts/FacetDefinition';
import { FacetMetadata } from '../Scripts/FacetMetadata';
import { IFacetValue } from '../Scripts/ISearchService';

@Component({
	components: {

	}
})
export default class FacetExplore extends Vue {
	private filter = '';

	get facets (): IFacetValue[] {
		return this.$store.state.currentFacetList;
	}

	get metadata (): IFacet | undefined {
		const currentFacet = this.$store.state.currentFacet;
		const searchType = this.$store.state.searchType;

		return FacetMetadata.list(searchType).find((m) => m.column === currentFacet);
	}

	get filtered (): IFacetValue[] {
		const query = this.filter.toLowerCase();

		let list = (this.filter)
			? this.facets.filter((f) => f.value.toLowerCase().includes(query))
			: this.facets;

		const metadata = this.metadata;

		if (metadata) {
			list = list.map((f) => {
				return { count: f.count, value: f.value, display: metadata.getTitle(f.value) } as IFacetValue;
			});
		}

		return list.sort((fa, fb) => fa.value === fb.value ? 0 : fa.value < fb.value ? -1 : 1);
	}

	public selected (facet: IFacetValue): void {
		this.$emit('selection', facet);
	}
}
